import { render } from "./LoaderComponent.vue?vue&type=template&id=24c6ce92&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=24c6ce92&scoped=true&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c6ce92"]])

export default __exports__